
import { ReactComponent as HomeIcon } from "@/assets/svgs/DesignSystem/home.svg";
import { ReactComponent as ArrowLeft } from "@/assets/svgs/DesignSystem/chevron-left.svg";
import { ReactComponent as ArrowRight } from "@/assets/svgs/DesignSystem/chevron-right.svg";
import classname from 'classnames'
import { Link } from 'react-router-dom';
import React from 'react';
import Tooltip from "@/componentsDS/Tooltip/Tooltip";
import useEllipsisCheck from "@/hooksDS/use-ellipsis-check/index";
import PropTypes from 'prop-types';

const Breadcrumbs = ({ dataTestId = 'breadcrumbs', breadcrumbItems }) => {
	const { isEllipsis, elementRefs } = useEllipsisCheck();

	return (
		<div className="DS__breadcrumbs-container" data-testid={dataTestId}>
			{breadcrumbItems?.map((item, index) => {
				const isCurrentPage = index === breadcrumbItems.length - 1;
				const isHomePage = item?.isHomePage ?? false;

				const breadcrumbItemClass = classname({
					'DS__breadcrumbs__item': true,
                    'DS__breadcrumbs__item--hidden': index !== breadcrumbItems.length - 2 && breadcrumbItems.length !== 1
				});

				const breadcrumbHomeClass = classname({
					'DS__breadcrumbs__home': true,
					'DS__breadcrumbs__home--active': isCurrentPage || isHomePage,
                   	'DS__breadcrumbs__home--inactive': !isCurrentPage && !isHomePage,
				});

				const breadcrumbLabelClass = classname({
					'DS__breadcrumbs__item-label': true,
                    'DS__breadcrumbs__item-label--active': isCurrentPage,
                    'DS__breadcrumbs__item-label--inactive': !isCurrentPage

				});

				const breadcrumbLeftArrowClass = classname({
					'DS__breadcrumbs__item-left-arrow': true,
                    'DS__breadcrumbs__item-left-arrow--shown': !isCurrentPage,
				});

				return (
					<div key={`${index}-${item?.label}`} className={breadcrumbItemClass} data-testid="breadcrumbs-item">
						{item.link === '/' && (
							<>
								{!isHomePage && (
									<div className={breadcrumbLeftArrowClass}>
										<ArrowLeft />
									</div>
								)}
								{(isCurrentPage || isHomePage) ? (
									<div className={breadcrumbHomeClass}>
										<HomeIcon />
									</div>
								) : (
									<Link to={item.link} className={breadcrumbHomeClass}>
										<HomeIcon />
									</Link>
								)}
							</>
						)}

						{item.link !== '/' && (
							<>
								{index !== 0 && (
									<div className="DS__breadcrumbs__item-right-arrow">
										<ArrowRight />
									</div>
								)}
								<Tooltip title={item.label} disabled={!isEllipsis[index]} offset={[0, -4]}>
									{isCurrentPage ? (
										<div className={breadcrumbLabelClass} ref={(el) => (elementRefs.current[index] = el)}>
											{item.label}
										</div>
									) : (
										<Link to={item.link} state={item.state} className={breadcrumbLabelClass} ref={(el) => (elementRefs.current[index] = el)}>
											{item.label}
										</Link>
									)}
								</Tooltip>
							</>
						)}
					</div>
				);
			})}
		</div>
	)
}

Breadcrumbs.propTypes = {
	dataTestId: PropTypes.string,
	breadcrumbItems: PropTypes.arrayOf(
	  PropTypes.shape({
		label: PropTypes.string,
		link: PropTypes.string,
		isHomePage: PropTypes.bool,
		state: PropTypes.object
	  })
	).isRequired
  };

export default Breadcrumbs

